import type { LifeEntrance } from '../types';
import type { BakedCrowd } from './crowdPlan';
import type { CrowdFrame } from './crowdSim';
import type { Residents } from './residents';

/* A leaf needs time to swing clear before a resident reaches its threshold. */
const OPEN_REACH_M = 2.4;

/** The cast and the residents share one physical leaf at each actual house opening. */
export function lifeDoorways(
  cast: readonly LifeEntrance[],
  crowd?: BakedCrowd
): readonly LifeEntrance[] {
  const entries = new Map(cast.map((entry) => [entry.id, entry]));
  for (const entry of crowd?.doorways ?? [])
    if (entry && !entries.has(entry.id)) entries.set(entry.id, entry);
  return [...entries.values()];
}

/** Door activity is independent of camera culling, so an off-screen resident opens its door too. */
export function crowdDoorActivity(
  open: Set<string>,
  frame: CrowdFrame | null,
  residents: Residents,
  baked: BakedCrowd
): void {
  open.clear();
  if (!frame) return;
  for (let i = 0; i < frame.count; i++) {
    if (!frame.moving[i]) continue;
    const door = residents.door[frame.resident[i]!]!;
    const entry = baked.doorways?.[door];
    if (!entry) continue;
    if (
      Math.hypot(frame.x[i]! - entry.position[0], frame.y[i]! - entry.position[1]) <= OPEN_REACH_M
    )
      open.add(entry.id);
  }
}
